"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _values = _interopRequireDefault(require("lodash/values"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var groupIndustriesByVertical = function groupIndustriesByVertical() {
  var industries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (industries.length === 0) {
    return industries;
  }
  var data = industries.map(function (industry) {
    return {
      vertical: industry.vertical.name,
      verticalId: industry.vertical.id,
      industry: industry.industry.name,
      industryId: industry.industry.id
    };
  });
  var dataGroupedByVertical = (0, _groupBy.default)(data, 'vertical');
  var dataMapped = (0, _mapValues.default)(dataGroupedByVertical, function (value, key) {
    return {
      name: key,
      results: value
    };
  });
  return (0, _values.default)(dataMapped);
};
var _default = groupIndustriesByVertical;
exports.default = _default;